import { useEffect } from 'react';
import { PlpSeoHead } from '@/shared/features/seo/presentation/components/PlpSeoHead';
import { recentlyViewedListingSeo, recentlyViewedSeo } from './recentlyViewed.seo';

export function RecentlyViewedSeoHead() {
  useEffect(() => {
    if (recentlyViewedSeo.title) {
      document.title = recentlyViewedSeo.title;
    }
  }, []);

  return <PlpSeoHead seo={recentlyViewedListingSeo} />;
}
